import { Box, styled, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import {
  ISubcommitteeResponsibilityFormValues,
  ISubcommitteesFormValues,
} from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import SubcommitteeActions from './SubcommitteeActions';

export interface ISubcommitteeModeState {
  mode: 'create' | 'edit';
  data?: ISubcommitteesFormValues;
  index?: number;
}

enum SUBCOMMITTEE_TABLE_COLUMN {
  ID = 'id',
  SUBCOMMITTEE_TYPE = 'subcommitteeType',
  SUBCOMMITTEE_ROLES = 'subcommitteeRoles',
  CHARTER_URL = 'charterUrlTh',
  ACTION = 'action',
}

export type ColumnActionProps = {
  getValues: UseFormGetValues<ISubcommitteeResponsibilityFormValues>;
  setValue: UseFormSetValue<ISubcommitteeResponsibilityFormValues>;
};

export const SUBCOMMITTEE_VISIBILITY = {
  [SUBCOMMITTEE_TABLE_COLUMN.ID]: false,
};

const UnorderList = styled('ul')(({ theme }) => ({
  margin: 0,
  paddingLeft: theme.spacing(5),
}));

export const SUBCOMMITTEE_COLUMNS: GridColDef[] = [
  { field: SUBCOMMITTEE_TABLE_COLUMN.ID, headerName: 'No.' },
  {
    field: SUBCOMMITTEE_TABLE_COLUMN.SUBCOMMITTEE_TYPE,
    headerName: 'ชื่อคณะกรรมการชุดย่อย',
    minWidth: 200,
    renderCell: (field) => {
      const { row } = field;
      return (
        <Box>
          <Typography>{row?.nameTh}</Typography>
          <Typography mt={2}>{row?.nameEn}</Typography>
        </Box>
      );
    },
  },
  {
    field: SUBCOMMITTEE_TABLE_COLUMN.SUBCOMMITTEE_ROLES,
    headerName: 'บทบาทหน้าที่และความรับผิดชอบ',
    minWidth: 400,
    flex: 1,
    renderCell: (fields) => {
      const { row, value } = fields;
      return (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            บทบาทหน้าที่
          </Typography>
          <Box mt={2}>
            {value?.nameTh?.map((name: string, index: number) => {
              if (name === 'อื่น ๆ') {
                return (
                  <Box key={index}>
                    <Typography component={'li'}>อื่น ๆ</Typography>
                    <UnorderList>
                      {row?.otherSubcommitteeRoles?.nameTh?.map(
                        (otherName: string, idx: number) => (
                          <Typography component={'li'} key={idx}>
                            {otherName}
                          </Typography>
                        )
                      )}
                    </UnorderList>
                  </Box>
                );
              }
              return <li key={index}>{name}</li>;
            })}
          </Box>

          <Box mt={2}>
            {value?.nameEn?.map((name: string, index: number) => {
              if (name === 'Other') {
                return (
                  <Box key={index}>
                    <Typography component={'li'}>Other</Typography>
                    <UnorderList>
                      {row?.otherSubcommitteeRoles?.nameEn?.map(
                        (otherName: string, idx: number) => (
                          <Typography component={'li'} key={idx}>
                            {otherName}
                          </Typography>
                        )
                      )}
                    </UnorderList>
                  </Box>
                );
              }
              return <li key={index}>{name}</li>;
            })}
          </Box>
          <Typography variant="subtitle2" fontWeight="bold" mt={4}>
            ขอบเขต อำนาจ หน้าที่และบทบาทความรับผิดชอบ
          </Typography>
          <Box mt={2}>
            <Typography>{row?.responsibilitiesTh}</Typography>
            <Typography mt={2}>{row?.responsibilitiesEn}</Typography>
          </Box>
        </Box>
      );
    },
  },
  {
    field: SUBCOMMITTEE_TABLE_COLUMN.CHARTER_URL,
    headerName: 'ลิงก์กฎบัตร',
    minWidth: 200,
    renderCell: (field) => {
      const { row } = field;
      return (
        <Box>
          <Typography style={{ wordWrap: 'break-word' }}>
            {row?.charterUrlTh || '-'}
          </Typography>
          <Typography mt={2} style={{ wordWrap: 'break-word' }}>
            {row?.charterUrlEn || '-'}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: SUBCOMMITTEE_TABLE_COLUMN.ACTION,
    headerName: 'แก้ไข/ลบ',
    headerAlign: 'left',
    type: 'actions',
    minWidth: 60,
    getActions: (field) => {
      const { id } = field;
      return [<SubcommitteeActions rowId={id} />];
    },
  },
];
